"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlFloatUniform = void 0;
const a_gl_uniform_value_1 = require("./a-gl-uniform-value");
/**
 * @public
 * wrapper for a single uniform float.
 */
class GlFloatUniform extends a_gl_uniform_value_1.AGlUniformValue {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        renderer.context.uniform1f(this.uniformLocation, this.data);
        this.isDirty = false;
    }
}
exports.GlFloatUniform = GlFloatUniform;
//# sourceMappingURL=gl-float-uniform.js.map